import { TextButton } from "../../form";
import { AccountMenuButtonProps } from "./AccountMenuButton.props";
import { AccountMenuItem } from "./AccountMenuItem";

export const AccountMenuButton = ({
  active,
  children,
  icon,
  iconPosition,
  onClick,
  ...props
}: AccountMenuButtonProps) => (
  <AccountMenuItem active={active} {...props}>
    <TextButton
      disabled={active}
      icon={icon}
      iconPosition={iconPosition}
      onClick={onClick}
      variant="secondary"
    >
      {children}
    </TextButton>
  </AccountMenuItem>
);
